import React from 'react';
//@ts-ignore
import * as styles from './blog-detail-masthead.module.css';
import { BlogDetailMastheadProps } from './index';
import RichText from '../Global/RichText';
import {
    getColor,
    getMediaData,
    optimizeKontentImageUrl,
    imagePreset,
    getDisplayDimensions,
    buildKontentSrcSet,
} from '../Global/DataUtils';
import { Taxonomy } from '../../templates/TaxonomyContext';

interface Props extends BlogDetailMastheadProps {
    blogTopics?: Taxonomy[];
    pageMetadata: {
        blogTitle?: string;
        blogShortDescription?: string;
    };
}

const BlogDetailMasthead: React.FC<Props> = ({
    kontentItemId,
    display_publish_date,
    top_summary,
    blogTopics,
    text_background_color,
    text_background_opacity,
    pageMetadata,
    ...props
}) => {
    const largeMastheadImage = getMediaData(
        props.general_large___small_image_selection__large
    );
    const smallMastheadImage = getMediaData(
        props.general_large___small_image_selection__small
    );
    const backgroundOpacity = text_background_opacity.value / 100 || 1;
    const backgroundColor = getColor(text_background_color) || '#4b5f5e';
    const authorStyles = {
        backgroundColor:
            backgroundColor + backgroundOpacity.toString(16).slice(2, 4),
    };

    return (
        <section
            className={styles.wrapper}
            data-kontent-item-id={kontentItemId}
        >
            <div className={styles.mastheadImage}>
                {largeMastheadImage && (
                    <picture data-kontent-element-codename="general_large___small_image_selection__large">
                        {smallMastheadImage && (
                            <source
                                media="(max-width: 576px)"
                                srcSet={buildKontentSrcSet(
                                    smallMastheadImage.url,
                                    imagePreset.fullWidth.mobile.w,
                                    {
                                        fm: 'webp' as const,
                                        q: imagePreset.fullWidth.mobile.q,
                                    }
                                )}
                                sizes="100vw"
                                {...getDisplayDimensions(
                                    smallMastheadImage.width,
                                    smallMastheadImage.height,
                                    imagePreset.fullWidth.mobile.w
                                )}
                            />
                        )}

                        <img
                            src={optimizeKontentImageUrl(
                                largeMastheadImage.url,
                                imagePreset.fullWidth.desktop
                            )}
                            srcSet={buildKontentSrcSet(
                                largeMastheadImage.url,
                                imagePreset.fullWidth.desktop.w,
                                {
                                    fm: 'webp' as const,
                                    q: imagePreset.fullWidth.desktop.q,
                                }
                            )}
                            sizes="100vw"
                            alt={
                                largeMastheadImage.description ||
                                largeMastheadImage.name
                            }
                            {...getDisplayDimensions(
                                largeMastheadImage.width,
                                largeMastheadImage.height,
                                imagePreset.fullWidth.desktop.w
                            )}
                            loading="eager"
                            decoding="auto"
                            fetchPriority="high"
                        />
                    </picture>
                )}
            </div>
            <div className={styles.headlinePanel} style={authorStyles}>
                <div
                    className={styles.subheading}
                    data-kontent-element-codename="display_publish_date"
                >
                    {display_publish_date.value}
                </div>
                <h1>{pageMetadata.blogTitle}</h1>
                {blogTopics?.length &&
                    blogTopics?.map((topic, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <span className={styles.topicLink}>
                                    {topic.name}
                                </span>
                                {idx != blogTopics.length - 1 && `, `}
                            </React.Fragment>
                        );
                    })}
            </div>
            <div className={styles.summary}>
                {RichText(
                    top_summary,
                    false,
                    undefined,
                    undefined,
                    'top_summary'
                )}
            </div>
        </section>
    );
};

function setAuthorStyles(brandColor: string, opacity: number) {
    return {
        backgroundColor: brandColor,
        opacity: opacity,
    };
}

export default BlogDetailMasthead;
